PegasusTemplate.MainTabPanelController = Ember.Controller.extend({
});
